export default [
  {
    path: '/circle-home-:uuid',
    component: () => import('@/views/circle/Home.vue'),
    name: 'circle.home',
    meta: {
      auth: 0,
      title: '圈子主页',
    },
  },
  {
    path: '/circle-shareHome-:uuid',
    component: () => import('@/views/circle/ShareHome.vue'),
    name: 'circle.shareHome',
    meta: {
      auth: 0,
      title: '圈子主页分享页',
    },
  },
];
